import type { ReactElement } from 'react'

import OrderWithdrawalConfirmationTemplate from '../../templateComponents/OrderWithdrawalConfirmation'

export default function OrderWithdrawalConfirmation(): ReactElement {
  return (
    <div className="order-withdrawal">
      <section className="section">
        <div className="wrapper">
          <div className="content">
            <OrderWithdrawalConfirmationTemplate />
          </div>
        </div>
      </section>
    </div>
  )
}
